var _style, _path, _linearGradient, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle, _linearGradient2, _path18, _g2, _linearGradient3, _ellipse, _ellipse2, _path19, _linearGradient4, _path20, _path21, _linearGradient5, _path22, _path23, _path24, _path25, _g3, _path26, _path27, _path28, _g4, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _linearGradient6, _path40, _g5, _linearGradient7, _path41, _path42, _path43, _path44, _linearGradient8, _path45, _path46, _ellipse3, _path47, _g6, _linearGradient9, _use, _g7, _path48, _linearGradient10, _path49, _linearGradient11, _path50, _path51, _g8, _linearGradient12, _path52, _use2, _linearGradient13, _use3, _linearGradient14, _path53, _path54, _linearGradient15, _path55, _path56, _ellipse4, _path57, _linearGradient16, _path58, _path59, _linearGradient17, _path60, _path61, _linearGradient18, _path62, _use4, _linearGradient19, _use5, _path63, _linearGradient20, _path64, _g9, _path65, _linearGradient21, _path66, _use6, _linearGradient22, _use7, _path67, _path68, _path69, _path70, _path71, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFig2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 350,
    height: 295.6,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".l{fill:#fc5b3f}.m{fill:#fff}.n{fill:#4c506d}.o{fill:#3e3e54}.p{fill:#2f3554}.q{fill:#fdb9a9}.r{enable-background:new}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.3 40.2c13.4 2.9 26.8 7 38.3 14.5 31.2 20.5 42 60.9 66.9 88.8 10.9 12.1 24.7 22.4 30.5 37.7 4.5 12.1 3.3 25.5 1.2 38.3-1.9 11.8-4.4 23.4-7.6 34.9-1.9 7.1-4.1 14.2-8.2 20.3-12.3 18.2-37.5 21.6-59.4 21.5-22.4-.2-44.9-2.5-66.9-6.8-11-2.2-22.1-4.8-33.3-5.6-24.3-1.7-48.3 5.4-72.4 9.6s-50.5 5.2-71.3-7.6C13 275.7 2.4 258.7.4 239.8c-1.3-13.7 2-27.2 5.6-40.5 4.6-17 9.7-33.9 15.2-50.8 4.3-12.9 8.9-25.9 15.9-37.7 31.2-52.3 117-82.9 174.2-70.6z",
    opacity: 0.18,
    className: "l r"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 92.398,
    y1: 168.337,
    x2: 104.509,
    y2: 331.763
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.08,
    "shrefp-opacity": 0.69
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.21,
    "shrefp-opacity": 0.32
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    "shrefp-opacity": 0
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.2 232.6l25.2 4.2c5.5 1 11.2 2.1 15.9 5.1 1.6 1 3.3 2.4 3.4 4.3.3 2.1-1.4 4.1-3.3 5-2 .7-4.2 1.1-6.2.9l-55 .4c-11.7.1-24.3-.2-33.4-7.6-1.5-1.1-2.7-2.6-3.4-4.4-.6-1.8-.1-3.9 1.4-5.1 1-.5 2.2-.9 3.3-.8l24.9-1.9",
    fill: "url(#A)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7 228.2c4.6-1.1 3.7 5.5 5 8 .8 1.3 1.7 2.4 2.9 3.3s1.9 2.3 2.1 3.7c0 .3 0 .5-.2.8s-.5.5-.9.5c-2.6.8-5.5.5-8-.8-1.2-.5-2.1-1.4-2.7-2.5-.5-1.2-.7-2.4-.7-3.7-.1-2.8-1.4-8.4 2.5-9.3z",
    className: "q"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7 241.8s13.2.5 7.6 4.7-13.9-1-14.8-2c-.8-1-.2-2.5-.2-2.5l7.4-.2z",
    className: "l"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1 243.6c1.2 1.4 7.3 3.3 10.1 3.2 2.8-.2 5.2-1.4 4.9-3.3-.4-1.8-5.2-5.9-6.1-5.9s-1.6 2.1-3.4 2.5c-1.6.3-3.3-.4-4.4-1.6-.4-.5-1-.6-1.5-.4-.6 1.8-.6 3.8.4 5.5z",
    className: "m"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7 230.8c4.6-1.1 3.7 5.5 5 8 .7 1.3 1.7 2.4 2.9 3.3s1.9 2.3 2.1 3.7c0 .3 0 .5-.2.8s-.5.5-.9.5c-2.6.7-5.5.5-8-.8-1.2-.5-2.1-1.4-2.7-2.5-.5-1.2-.7-2.4-.7-3.7-.1-2.9-1.3-8.5 2.5-9.3z",
    className: "q"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8 244.2s13.2.5 7.6 4.7-13.9-1-14.7-2c-.7-1-.2-2.5-.2-2.5l7.3-.2z",
    className: "l"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3 246c1.2 1.4 7.3 3.3 10.1 3.2s5.2-1.4 4.9-3.3c-.4-1.8-5.2-5.9-6.1-5.9s-1.6 2.1-3.4 2.5c-1.6.3-3.3-.4-4.4-1.6-.4-.5-1-.6-1.5-.4-.8 1.9-.7 3.9.4 5.5z",
    className: "m"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#473f47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.7 171l-6.2 65.2-9-1.1c-3.5-16-2.5-63.6-2.5-63.6l17.7-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4 169.3l6.2 65.2 9-1.1c5.1-41.3.9-66.9.9-66.9l-16.1 2.8z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.7 145.6c.1-1.2.5-2.4.5-3.6.3-2.4.3-5-.2-7.4-.5-2.6-1.2-5.2-2.4-7.5-1-2.1-2.9-2.9-5-4-1.7-.9-3.6-1.6-5.6-1.9-1.4-.1-2.8-.1-4.2.2-4.3.8-9.8 3-12.7 6.3-2.2 2.5-2.4 6.1-2.4 9.3a157.45 157.45 0 00.3 13.7c0 .6.1 1.4.2 2 .4 5 .8 10.1 2.2 15 .5 1.5.9 3.1 2.4 3.8 3.3 1.9 8.3.8 11.9.4 4.7-.6 9.6-1.4 13.8-3.7.9-.4 1.5-1.1 2-1.9.4-1-.1-2.2-.4-3.2-1.4-4.6-.4-9.6-.4-14.3 0-.8-.1-1.7-.1-2.6.1-.1.1-.4.1-.6z",
    className: "m"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3 125.5c.1 1.6 0 3.2-.2 4.8l.1 4.3c-.1 2.4-1 4.9-2.4 6.9l11.6-2.4c.3 0 .5-.1.6-.4.1-.2.1-.5 0-.6l-1-4.5c-.4-2.3-1.2-4.4-2.4-6.4-1.3-1.7-3-3.1-4.9-4.1-.5-.2-1.9-1.3-2.4-.5-.1.3.9 2.5 1 2.9z",
    opacity: 0.1,
    fill: "#020202",
    className: "r"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2 137a4.46 4.46 0 013.9-.3c1.3.6 2 1.9 2.1 3.3a6.22 6.22 0 01-.9 2.6c-.3.5-.6.9-1.2 1.3-.7.5-1.6.6-2.4.5-.8 0-1.5-.3-2.2-.6-1-.5-2.4-2.2-2-3.4.5-1.5 1.4-2.6 2.7-3.4z",
    className: "q"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82 167.3c.7-1.8 1.1-3.7 1.1-5.6-.1-1.8-.4-3.6-.8-5.3l-3-14.4c-.5-2.6-1.7-15.4-5.8-13.9-2.3 1-4 2.9-4.7 5.2s-1 4.8-.8 7.2c.1 6.3 1.4 12.9 2.2 19.1.3 2.4.7 11.2 3.8 12 .6.2 1.2.5 1.8.5 1.1.2 4.3 1.4 5.6 1 .3-.1.5-.2.5-.4.8-1.6-.5-4.7-.5-6.5.2-2.9 1.4-5.7 3.3-7.9 2.3-2.3 4.7-4.3 7.5-5.9l3.7-2.4c.6-.5 1.4-.7 2.1-.8.5.1 1 .2 1.5.2.8-.1 1.3-1 1.5-1.7.7-1.8 1.1-3.8 1-5.8 0-.3-.1-.5-.3-.7-.3-.2-.5-.2-.8 0l-11.7 3.6c-1.7.7-3.6 1-5.4.8-1.8-.3-3.6-1.7-3.6-3.5",
    opacity: 0.1,
    fill: "#020202",
    className: "r"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2 129.1c-3.8 6.3-5.2 13.8-6.4 21.1-.2.9-.3 1.8-.1 2.7.5 1.6 1.8 2.9 3.4 3.3s3.3.5 5 .3c3.5-.3 7.8-.5 10.8-2.6 1-.7 2-1.6 3-2.3s2.1-1.2 3.2-1.6c2.1-1 4.2-2.2 6-3.5a6.09 6.09 0 001.6-1.6c.6-1.3.2-2.7-.4-4-.1-.6-.6-1.1-1.3-1-.2 0-.4.1-.5.2-5.1 1.5-10.3 2.7-15.6 3.4-1.4.2-.8-1.4-.6-2.2.3-1.2.5-2.4.7-3.5a10.49 10.49 0 00-3.6-9.1c-.6-.6-1.5-1-2.4-1.2-.9.1-2 .7-2.8 1.6z",
    className: "m"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7 114.7c0-1.3-.1-2.5-.2-3.7-.1-1.1-.3-2.2-.5-3.3 0-.6-.4-1.3-.8-1.6-1.6-1-3.6-1.5-5.6-1.5-2.4-.4-4.7 1.4-5.1 3.7 0 .3-.1.5-.1.7-.3 2.7.5 5.4.8 8.2.3 2.1.5 4.3.4 6.3 1 .7 2.2 1.1 3.4 1.2.5 0 1.2-.1 1.7-.3.3-.1.5-.3.7-.5.1-.2.1-.5.1-.7s-.1-.5-.1-.6c-.1-1.3-.1-2.5.1-3.7 0-.1 0-.2.1-.3h.7c.6.1 1.3.1 1.9 0 .7-.1 1.4-.5 2-1 .4-.9.6-1.9.5-2.9z",
    className: "q"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3 114.9c-.1-.2-.4-.5-.5-.4-.2.1-.3.3-.3.4-.3.6-.6 1.3-1.1 1.8-.3.4-.5.6-.9.9l-.6.5c.5.2 1.2.4 1.7.4.6.1 1.2-.2 1.6-.5.3-.3.5-.5.5-.9.2-.3.3-.6.4-1 0-.4-.1-.6-.3-.9",
    fill: "#de9f93"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2 106.5c1-.3 2.5-.4 3-1.4.4-1 .1-2.1-.8-2.7-1.4-1.4-3.5-2.2-5.5-1.8-.6.2-1.3.3-1.9.4-.8.1-1.7-.2-2.5-.3a6.29 6.29 0 00-4.1 1.5c-.7.7-1.5 1.4-2.4 1.8s-2.1.3-2.7-.5a3.94 3.94 0 00.5 3.5c-.4.4-.9.4-1.4.1.1 1.4.4 2.9 1 4.2-.5.1-1.1 0-1.6-.1.6 1.4 1.8 2.6 3.3 3.3 2 .8 4.3.9 5.7 2.6.2.2.4.7.6.8.3.1.5-.3.6-.5.4-1.3.3-2.5-.3-3.7-.4-.5-.5-1.3-.6-1.9.1-.6 1-1.2 1.4-.8.5.4.5 1.4 1.1 1.2-.6-1.9.2-4.3 2-5.1 1.4-.5 3-.2 4.3-.6h.3z",
    fill: "#dd8049"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2 118.5c-1.4-.3-2.9-.7-4.3-1.3-.1 4.4 3.5 5.3 3.5 5.3-.1-1.3-.1-2.5.1-3.7 0-.1 0-.2.1-.3h.6z",
    fill: "#de9f93"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 162.2,
    cy: 127.5,
    r: 34.4,
    className: "m"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 203.785,
    y1: 128,
    x2: 190.217,
    y2: 325.258
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.08,
    "shrefp-opacity": 0.69
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.21,
    "shrefp-opacity": 0.32
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    "shrefp-opacity": 0
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M265.5 246.3c-5.4 1.8-10.7 4.3-10.5 7 .2 2.9-22.1 3.4-24.3 3.1.5-.9.1-2.4.5-3.3-8.1-1.9-16.2-4.3-24-7.3-10.3-3.8-22.6-4.4-33.5-5.4-24.3-2.4-49.1-1.9-72.7 4.8-5.2 1.4-10.1 3.3-14.8 5.7-1.4.6-2.5 1.6-3.3 2.9-1.4 2.5.4 5.7 2.5 7.6 3.3 3 7.7 4.5 11.9 5.7 14.1 4.1 28.8 5.4 43.4 4.2 6.3-.5 12.8-1.6 19.1-.5s12 4.3 18.2 5.9 13.6 1.4 17.9-3.3c1.1-1.2 2-2.5 3.3-3.3 1.7-1 3.9-.7 5.8-.5 18.5 2.5 37.1 2.7 55.6.4 1.5-.2 3.2-.5 4.1-1.7.7-.9.8-2.2 1.6-3 1-1.2 2.7-1.2 4.3-1.2 9.1 0 18.2-.5 27.2-1.7 2.4-.4 4.9-.7 6.9-2.1s3.4-3.9 2.6-6.2c-.6-1.4-1.6-2.6-2.9-3.4-7.9-6-18.2-8.3-28.1-7.1-3.5.5-7.2 1.5-10.8 2.7z",
    fill: "url(#B)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.8 248.1c0 2.1 7.2 3.8 16 3.8s16-1.7 16-3.8c.1-.8.1-1.5 0-2.4-1.2-1.8-8-1.4-16-1.4-7.8 0-14.5-.3-16 1.4-.1.8-.1 1.6 0 2.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.8,
    cy: 245.7,
    rx: 16,
    ry: 3.8
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 192.466,
    y1: 227.584,
    x2: 173.106,
    y2: 264.105
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.08,
    "shrefp-opacity": 0.69
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.21,
    "shrefp-opacity": 0.32
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    "shrefp-opacity": 0
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.8,
    cy: 245.7,
    rx: 16,
    ry: 3.8,
    fill: "url(#C)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.9,
    cy: 250.1,
    rx: 16,
    ry: 3.8,
    className: "n"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M180.9 210h3.7v36h-3.7z",
    className: "l"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 194.162,
    y1: 200.699,
    x2: 162.565,
    y2: 243.764
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.08,
    "shrefp-opacity": 0.69
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.21,
    "shrefp-opacity": 0.32
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    "shrefp-opacity": 0
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M180.9 210h3.7v12.4h-3.7z",
    fill: "url(#D)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M229.1 243.9v5.5h-19.6s1.2-4.2 9-5.5l2.5-2.1 8.1 2.1z",
    className: "l"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 231.166,
    y1: 244.075,
    x2: 201.433,
    y2: 251.714
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.08,
    "shrefp-opacity": 0.69
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.21,
    "shrefp-opacity": 0.32
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    "shrefp-opacity": 0
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M229.1 243.9v5.5h-19.6s1.2-4.2 9-5.5l2.5-2.1 8.1 2.1z",
    fill: "url(#E)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M208.8 249.4H230v1.4h-21.2z",
    className: "l"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M270.4 218.4h3.1v28.4h-3.1z",
    className: "n"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M256 250.1c0 2.1 7.2 3.8 16 3.8 8.9 0 16-1.7 16-3.8.1-.8.1-1.5 0-2.4-1.2-1.8-8-1.4-16-1.4-7.7 0-14.5-.3-16 1.4-.1.8-.1 1.6 0 2.4z",
    className: "p"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "n"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.9,
    cy: 247.7,
    rx: 16,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 213.3h26.4l6.3-34.4c.4-2.3-1.1-4.3-3.3-4.8-.3 0-.5-.1-.8-.1h-18.1c-2 0-3.7 1.4-4.1 3.3l-6.4 36z"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M260 213.3h26.4l6.3-34.4c.4-2.3-1.1-4.3-3.3-4.8-.3 0-.5-.1-.7-.1h-18.1c-2 0-3.7 1.4-4.1 3.3l-6.5 36z",
    className: "p"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M269.5 208.1h19.1c2.9 0 5.2 2.4 5.2 5.2 0 2.9-2.4 5.2-5.2 5.2h-19.1c-2.9 0-5.2-2.4-5.2-5.2-.1-2.9 2.3-5.2 5.2-5.2z",
    className: "n"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M257.8 208.1h19.1c2.9 0 5.2 2.4 5.2 5.2 0 2.9-2.4 5.2-5.2 5.2h-19.1c-2.9 0-5.2-2.4-5.2-5.2 0-2.9 2.3-5.2 5.2-5.2z",
    className: "p"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.9 164.8c-.2-.3-.4-.5-.6-.6-3.1-3-8.1-2.6-11.3-2.5-2.8.1-5.6 0-8.4-.3l-1.2-.2h-.4c-2.1-.2-4.6-.2-5.3 2-.8 2.6-.9 5.7-1.3 8.3-1.1 8-1.7 15.8-2.1 23.8-.4 7.1 9.1 7.6 14.1 7.6 1.7 0 3.4-.1 5.2-.3 1.5-.3 3-.9 4.5-1.2.8-.1 1.5-.4 2.2-.9.9-.8.9-2.2.9-3.4 0-3.1.2-6.1.7-9.1l1-4.4c.3-1.2.7-2.4 1.3-3.5 2.1-5.4 3.8-11.5.7-15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.8 165.6c.2-.7.5-1.4.9-1.9 1-1.3 2.7-1.4 4.3-1.6.7-.1 1.6 0 2 .6.2.4.2.7.1 1.2l-.4 4c1-.6 2.2-1.2 3.3-1.4.3-.1 3.4-.5 3.4 0a56.33 56.33 0 01.3 5.8c.1 1.4-.3 2.8-1.3 3.9-1.6 2.4-3.5 4.5-5.5 6.5-2.2 2.2-5.1 3.3-8.1 3.4-1 .2-1.9-.2-2.6-.9-.3-.5-.5-1.1-.4-1.7 0-1.7.2-3.4.5-5.1.8-4.5 2-8.7 3.5-12.8z"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M245.5 169.3c.2-1.1 0-3.7.9-4.4l.2-.1c.8-.4 1.8-.1 2.3.8.2.5.2 1 .1 1.4-.1 1.2-.1 2.4.1 3.6.1.7.4 1.5 1 1.8.5.1 1.1 0 1.4-.3a11.44 11.44 0 003.3-2.3c.2-.2.5-.4.8-.3a.78.78 0 01.4.4l7.4 11.5c.6 1 1.2 2.4.5 3.2s-2 .5-3 .1c-2.9-1.3-5.4-3.1-7.6-5.4l-.5-.5c-.4 0-.6.1-.9.4-1.4 1-2.8 1.9-4.3 2.6-1.1.5-2.7.9-3.4-.2-.3-.5-.4-1.3-.2-1.9l1.5-10.4zm27.4 3c.5-1.4 1.4-2.6 2.5-3.5 1.2-1 2.8-1.1 4.2-.5 1.7 1.1 1.9 3.5 1.7 5.5-.3 2.9-1 5.8-1.9 8.5-.5 1.4-1.3 2.7-1.6 4.1-.4 1.1-.4 2.4-.7 3.4-.9 2.9-1.4 5.9-1.4 9 0 .4-.1.8-.2 1.2-.2.4-.5.5-1 .5-.3-.1-.5-.3-.5-.5-1.9-2.4-5.2-3.3-8.3-3.6-3.6-.5-7.2-.5-10.9-.7-1.4-.1-3.3-.5-3.6-2-.1-.9.4-1.7 1.1-2.2s1.5-.7 2.4-.8c3.3-.6 6.6-1.1 9.3-3-1-.3-1.9-.8-2.6-1.4 1.7 1.2 4.5-2.6 5.8-3.5 1.1-.9 2-2 2.7-3.2 1.2-2.4 1.9-5 3-7.3z",
    fill: "#d8dae1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M263.5 163.7c.4-.1.8 0 1.2.2s.7.3 1.2.3v.1c.5 1.1 0 2.3-1 2.8-.2.1-.5.2-.6.3-.3.4-.5.8-.4 1.3.1 3.7-1 7.4-1.9 11-1 4.3-1.7 8.7-1.1 13v.7c-.1.2-.2.3-.3.5l-1.9 2.2c-.5-.9-1.9-1.2-2.2-2.2-.1-.3-.1-.6-.1-.9.4-4.1 1.1-8.1 2.1-11.9 1-4.5 2.3-8.9 3.9-13.2.1-.2.1-.4.1-.5 0-.2-.1-.3-.2-.4-.5-1.1.3-3 1.2-3.3z",
    className: "l"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M273.3 161.6l-8.1-.5c-1.8-.1-4.2-.5-5.8.2.4 0 .8.1 1.2.2 2.8.3 5.6.4 8.4.3 3.2-.1 8.2-.5 11.3 2.5-1.7-2-4.4-2.5-7-2.7z",
    className: "m"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M270.9 153.4c.3.2.6.3.9.1-.4 2.1-.7 3.9.3 5.9.4.9 1 1.5 1.9 1.9-1.8.4-3.5 1-5.2 1.7-1.1.5-2.3.7-3.4.7-.1 0-2.2-.5-1.9-.9 1.6-2.4.4-6.4.4-6.4 2.8.8 5.9-.6 6.9-3.4 0 .2 0 .3.1.4z",
    fill: "#8c6239"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M269.2 138.1s-11.1-.8-11.3 7c0 1.6.1 3.2.5 4.8l.4 1.6c1.4 4.7 4.6 7.9 8.4 6.8 6.7-2.1 10.9-18.2 2-20.2z",
    fill: "#a67c52"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M272.4 151.3c.8-.8 1-2.1.4-3.1-.1-.2-.3-.3-.4-.4-.4-.2-.8-.2-1.3.1-.3.2-.7.8-1.1.4-.2-.2-.3-.5-.2-.8.1-.7.4-1.4.9-2-.6-.2-1.1-.6-1.3-1.3-1 .2-2.1.3-3.2.2-.3 0-.5-.1-.7-.2-.5-.3-.7-.9-1.3-1.3s-1.4-.5-2.2-.3c-.7 0-1.6-.3-1.8-1-1.4.5-3-.1-3.5-1.4-.7.3-1.4.2-2.1-.3-.4-.5-.5-1.3-.3-1.9.3-1.4.9-2.9 2.3-3.3-.8-.4-.7-1.4-.6-2.4 0-.3.1-.5.2-.7.4-.5 1.2-.5 1.8-.8s1.1-.7 1.7-1 1.4-.3 1.8.4a5.77 5.77 0 012.6-.9c.9-.1 1.8.4 2.4 1.1.5-.3 1-.5 1.4-.5a1.3 1.3 0 011.2.8c0 .1.1.3.2.3.1.1.2.1.4 0 .7-.3 1.4-.4 2.3-.2.7.2 1.3.8 1.4 1.6.9.3 1.7.7 2.4 1.4.7.5 1.1 1.4.9 2.4 1.2 1.3 1.3 3.2.2 4.5.4.2.5.5.5.9s-.2.7-.5 1c-.1.1-.1.2-.1.4s.2.3.3.4c.5.6.5 1.5-.1 2.1-.1.1-.3.2-.4.3.5.4.8.9.8 1.5a1.08 1.08 0 01-1 1h-.2a1.84 1.84 0 01-.3 2c-.5.7-1.2.5-1.8.8-.6.4-1 1.3-1.4 1.8-.1-.7-.3-1.2-.3-1.6zm-23.5 45.8l-15.2 7.8-12.7 36.7 7.7 4.7 15-30.4 17.7-5.5c3.7-1.3 8.5-13 8.5-13l-21-.3z",
    className: "p"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M260.9 198.4l-15.2 7.8-10.6 42.8 8.1 2.1 12.5-33.9 17.7-5.5c3.7-1.2 2.9-11.9 2.9-11.9-6.5-4.6-15.4-1.4-15.4-1.4z",
    className: "n"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M276.3 163.3c-2.4-.5-8.2 11.9-8.2 11.9l-9.5-9.5-5.6 2.2s8.5 20.8 15.5 18.8 13.7-16.9 13.7-16.9c.8-2.6-3.5-6-5.9-6.5z",
    className: "m"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M247.6 156.9c-.6.5-1.2 1.3-1.6 2.1-.5.8-.7 1.7-1 2.6-.3.7-.3 1.4-.3 2.2.1.7.5 1.4 1.1 1.7 1 .4 2.1.1 2.8-.7.6-.8 1-1.8 1.2-2.8s.5-2 .9-3a3.4 3.4 0 00.7-1.5c0-2.2-2.8-1.5-3.8-.6z",
    fill: "#8c6239"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M257 164.4c.5 2.2-2 3.1-3.8 2.6-.5-.1-1.1-.4-1.5-.7-1.1-.8-1.4-2.3-2.1-3.4-.5-.8-1.2-1.4-1.6-2.4-.5-.8-.6-1.8-.3-2.7.6-1.1 2.1-1.3 3.3-1.3.6-.1 1.3 0 1.9.3.6.4 1.2.9 1.5 1.5 1.1 1.8 2 3.9 2.6 6.1z",
    fill: "#a67c52"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M92 200.5c0 7.8 39.3 14 87.7 14s87.7-6.2 87.7-14c0-.4.1-4.2 0-4.5-3.1-7.3-41.3-9.5-87.7-9.5-45.4 0-83.2 2.4-87.7 9.5-.3.4 0 3.9 0 4.5z",
    className: "l"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientUnits: "userSpaceOnUse",
    x1: 182.837,
    y1: 104.159,
    x2: 176.529,
    y2: 300.549
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.08,
    "shrefp-opacity": 0.69
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.21,
    "shrefp-opacity": 0.32
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    "shrefp-opacity": 0
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M267.3 200.5c0 7.8-39.3 14-87.7 14s-87.7-6.2-87.7-14c0-.9-.1-1.8 0-2.7.1-.5.3-1.1.6-1.5.6-1.9 2.4-3 4.3-2.8 2 0 4.1 0 6.1.1 2.8.1 5.6.4 8.3.7 2.1.3 4.2.7 6.2.8 4.3.3 8.6-.7 12.9-.9.4 0 .6 0 1 .1s.6.3 1 .5c1.5.8 3.3 1.1 5.1.8 15.6 1.1 31.1 0 46.7-1.8 12.9-1.5 25.9-3.3 39-3.7 13.7-.4 27.3.9 40.6 3.9 1.8.4 4 1.3 4.1 3.1 0 1.1-1.3 2.4-.5 3.4z",
    fill: "url(#F)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "l"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.7,
    cy: 196,
    rx: 87.7,
    ry: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.2 251.1v5.4h-19.6s1.2-4.2 9-5.4l2.5-2.1 8.1 2.1z"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 245.291,
    y1: 251.177,
    x2: 215.558,
    y2: 258.825
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.08,
    "shrefp-opacity": 0.69
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.21,
    "shrefp-opacity": 0.32
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    "shrefp-opacity": 0
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M243.2 251.1v5.4h-19.6s1.2-4.2 9-5.4l2.5-2.1 8.1 2.1z",
    fill: "url(#G)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M222.9 256.5h21.2v1.4h-21.2z",
    className: "l"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M272.3 160.5c.3-.1.6-.1.9 0 .5.2.6.8 1.1 1-1.1 1-2.5 1.4-3.8 2.3s-2.4 2-3.4 3.2c-1.2-.6-1.1-2.4-2.1-3.3.7-.2 1.4-.5 2.1-.9.5-.3 1-.5 1.4-.8 1.1-.9 2.4-1.3 3.8-1.5zm-10.1.6l-1 1.1-1.2 1.4c-.1.1-.2.3-.2.5a.55.55 0 00.5.3c.2-.1.4-.1.5-.2.5-.1.9-.1 1.3-.1.5-.1 1.1-.2 1.5-.4.1 0 .1-.1.2-.1v-.2c0-.5.1-1 .3-1.5.1-.4.4-.8.1-1.2-.4-.7-1.5.1-2 .4zm-25.5 27.8l-22.8 1 7 8.1 25.1-2zm-94.8 0c1.3.1 22.4 6.2 22.4 6.2l-12.3 9.4-24.2-6.5 14.1-9.1z",
    className: "m"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M238.9 232.6h3.1V261h-3.1z",
    className: "n"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    gradientUnits: "userSpaceOnUse",
    x1: 241.751,
    y1: 260.663,
    x2: 239.714,
    y2: 239.765
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0,
    "shrefp-opacity": 0
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.99
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M238.9 232.6h3.1V261h-3.1z",
    fill: "url(#H)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M224.4 264.3c0 2.1 7.2 3.8 16 3.8s16-1.7 16-3.8c.1-.8.1-1.5 0-2.4-1.2-1.8-8-1.4-16-1.4-7.7 0-14.5-.3-16 1.4-.1.8-.1 1.6 0 2.4z",
    className: "p"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.4,
    cy: 261.9,
    rx: 16,
    ry: 3.8,
    className: "n"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M226.2 174.6c-10.3-2.4-15.6-14.9-25.6-18.2-.4-.1-.7-.1-1 0-.3.2-.5.5-.5.7l-2.4 5.1 13.8 16.1c1 1.3 2.2 2.4 3.4 3.5 3 2.3 6.8 3 10.5 3.7 2.2.4 4.4.8 6.6.2 2.8-.8 6-4.6 5.1-7.8-1-3.4-7.1-2.7-9.9-3.3z",
    className: "m"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211 226.7c-.1 1.6.3 3.3.9 4.9h.1c1.8-.1 3.5 0 5.3.1l8.8 1.3 4 .8 3.8.8 7.1 1.2c2.9-1.3 5.5-3.1 7.7-5.5.3-.3.5-.5.6-.8l.8-1.1c.7-1.1 1.2-2.3 1.4-3.5.1-.5 0-1.1-.1-1.5-.5-1.7-1.5-3.3-3.1-4.3l-.5-.4c-3.3-2.3-7.1-3.3-11-3.3-.4 0-.6 0-1 .1-2.1.2-4.2.5-6.2 1.1-3.3.8-6.4 2-9.6 3-2.4.6-4.6 1.6-6.7 2.8a6.73 6.73 0 00-1.5 1.4c-.6.9-.9 1.9-.8 2.9z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#X"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    gradientUnits: "userSpaceOnUse",
    x1: 214.874,
    y1: 193.775,
    x2: 242.055,
    y2: 273.624
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0,
    "shrefp-opacity": 0
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.99
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#X",
    fill: "url(#I)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.5 232.4c-1.7 2.1-3 4.3-4 6.8-1.3 2.8-8.3 32.5-8.6 32.4l5.3 1.4c6.2-8.9 11.4-18.5 15.5-28.5 1.2-2.9 1.3-3.2 4.3-3.8 2.8-.5 5.5-1.1 8.2-1.8 5.3-1.3 10.6-2.9 15.7-4.9 3.1-1.2 6.1-2.7 8.9-4.5.4-.3.7-.6 1.1-1.1.2-.2.3-.4.4-.5.5-.8.7-1.7.6-2.6 0-.3-.1-.5-.1-.7-.2-.5-.5-1-.8-1.4-.5-.7-1.2-1.3-1.9-1.7-1.9-1.4-4.2-2.2-6.5-2.4-1.6-.1-3.2.2-4.7.2-1.4-.1-2.4-.8-3.6-1-.9-.1-1.9 0-2.8.3-2.1.7-4.1 1.6-6.1 2.7l-11.3 5.6h-.1l-2.3 1.1c-2.4 1.2-5.1 2.4-7 4.3l-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9 270.2c-1 .1-2 .4-2.8.9s-1.2 1.6-.9 2.5c.4.6.9 1.2 1.5 1.4 3.9 1.9 8.3 2.8 12.7 2.4.6 0 1.3-.1 1.7-.5a2.72 2.72 0 00.8-1.6c.4-1.2.5-2.4.3-3.5-.7-2.4-3.3-1.9-5.2-2-2.6 0-5.3.1-8.1.4z"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M156 205.1v3.3h131.2l.5-3.3H156z",
    className: "l"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    gradientUnits: "userSpaceOnUse",
    x1: 258.773,
    y1: 164.384,
    x2: 210.114,
    y2: 219.922
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.08,
    "shrefp-opacity": 0.69
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.21,
    "shrefp-opacity": 0.32
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    "shrefp-opacity": 0
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M156 205.1v3.3h131.2l.5-3.3H156z",
    fill: "url(#J)"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    gradientUnits: "userSpaceOnUse",
    x1: 219.638,
    y1: 167.262,
    x2: 235.011,
    y2: 167.262
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0,
    "shrefp-color": "#e5c5d5"
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.42,
    "shrefp-color": "#ead4d1"
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    "shrefp-color": "#f0e9cb"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M220.6 165.3c-.5.5-1.2 1.2-.9 1.8.2.4.5.5.8.7.8.7 1.3 1.6 1.4 2.7.1 1 .4 2.1.7 3 .5 1 1.5 1.4 2.5 1.3.5-.2 1.1-.8 1.7-.6s.6.6.9 1.1c.7.9 1.9 1.4 3.1 1.1 1.1-.3 2.2-.8 3.1-1.4.4-.2.7-.5 1-.9.2-.4.2-.8 0-1.2-.5-1.2-1.2-2.2-2-3.1-1.4-1.8-2.4-3.9-2.7-6.2-.3-1.5-.4-3.3-1.4-4.4-1.5-1.5-4.8-1.2-6.3.2-1.9 1.3-.5 4.1-1.9 5.9z",
    fill: "url(#K)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M221.8 157.9c.3.4.5.7 1 .9l2.3 1.3c.7.4 1.3 1.1 1.5 1.9.5 1.4-.2 3.2.4 4.5.2.3.6 0 .8-.3s.2-.7.5-.9c.5-.4 1.1.1 1.4.6.5 1.3.1 2.7-1.1 3.3.1.5.7.5 1.2.5.5-.2.9-.3 1.4-.4 1.1.1 1.6 1.6 2.7 1.6.7 0 1.3-.6 1.7-1.3l1.2-1.6c.2-.3.4-.6.6-.8.3-.3.7-.4 1-.6.3-.3-.1-.9.1-1.3.1-.2.3-.3.5-.4.7-.5 1-1.4.7-2.2-.1-.1-.1-.2-.1-.3 0-.2.2-.2.4-.3.7-.6 1-1.7.5-2.5s-1.2-1.5-2-2c-1.6-1.3-3.4-2.6-3.9-4.7a9.83 9.83 0 00-.5-1.6c-.3-.5-.9-.7-1.4-.5.1-1.1.1-2.1-.2-3.2-.1-.3-.2-.5-.4-.7-.4-.4-.8-.5-1.3-.4s-.9.4-1.3.6c0-.5-.6-.7-1.2-.7-2 .1-3.7 1.2-4.7 2.9-.1.2-.2.3-.3.5-.2.2-.5.3-.7.4-.8.5-1.4 1.3-1.4 2.1-.2.9-.2 1.8 0 2.6 0 .7.2 1.4.4 2l.2 1z",
    fill: "#dd8049"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.1 173.1c-1.1.6-2.2 1.4-3.3 2.1-.4.3-.6.5-.8.9s-.2.8 0 1.2c.4.5 1 .3 1.5 0 2.4-1.1 5-1.7 7.6-1.8.4 0 .7-.2.9-.5.1-.4 0-.7-.2-1.1-1.5-2.7-3.6-2.1-5.7-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.5 206.9c-1.8-3.7-2.7-7.6-4-11.6-3 2.4-3.3 6.6-6 9.4-.4.5-.8.8-1.4 1.1-1.8 1-4.4.5-6.4.5-1-.1-2-.5-2.7-1.2-.5-.6-.7-1.4-.7-2.1-.2-2.6 1.3-5 2.7-7.1l9.8-14.9c.7-1.4 2-2.3 3.5-2.5 6.2-1.8 12.5-3.3 18.8-4.4.9-.2 1.9-.3 2.9-.2 2.7.4 4.5 3 5.9 5.3 7.2 12.4 12.2 26.4 11.4 40.7 0 .8-.2 1.5-.4 2.3-.5 1.1-1.3 2.1-2.3 2.8-3.2 2.5-7.4 3.4-11.4 3.5-6.1.1-14-1.8-18.6-6.2-2.5-2.4 0-4 1.3-6.3 1.5-3-1.1-6.3-2.4-9.1z"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    gradientUnits: "userSpaceOnUse",
    x1: 289.284,
    y1: 253.84,
    x2: 211.445,
    y2: 176.001
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.08,
    "shrefp-opacity": 0.69
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.21,
    "shrefp-opacity": 0.32
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    "shrefp-opacity": 0
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M257.7 196.9c-.5-1.9-1.1-3.7-1.8-5.5-3.5 2.5-6.2 7.4-7.4 11.6-1.3 4.2-2.4 8.5-5.1 11.9l-2.9-1-.5 1.8c-.5 1.4.8 2.9.6 4.3-.3 1.5-1.4 2.7-3 3.1-1.7.4-3.4.2-5.1-.4-1.1-.2-2.1-.6-3-1.3s-1.4-1.8-1.1-2.9c-.7.5-1 1.3-.8 2.1.3.8.7 1.4 1.4 1.9 2 1.8 4.5 2.7 7.1 3.7 1.2.5 2.4.9 3.6 1.3 2.9.6 5.8.9 8.7.9 1.8.1 2.8-.3 3.6-2 1.1-2.5 1.2-5.3 1.4-8.1 1-7.1 2.4-14.3 4.3-21.4z",
    fill: "url(#L)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Y",
    className: "o"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientUnits: "userSpaceOnUse",
    x1: 281.947,
    y1: 211.715,
    x2: 247.979,
    y2: 211.715
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0,
    "shrefp-opacity": 0
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.99
  }))), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Y",
    fill: "url(#M)"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    gradientUnits: "userSpaceOnUse",
    x1: 187.681,
    y1: 154.897,
    x2: 200.593,
    y2: 154.897
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0,
    "shrefp-color": "#e5c5d5"
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.42,
    "shrefp-color": "#ead4d1"
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    "shrefp-color": "#f0e9cb"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M196.5 152.9c-2-1.7-4.2-3.5-6.7-4.3a1.08 1.08 0 00-1.1 0c-.2.2-.3.4-.3.5-.1.9.3 1.8.9 2.4s1.3 1.4 1.7 2.1c-.9-.2-1.9-.1-2.8.1a.55.55 0 00-.5.3.78.78 0 00.1.8c.7 1.1 2 1.8 3.3 1.8.3 0 .5.1.7.2.5.4.2 1.1.3 1.6s.5 1 1 1.3 1 .4 1.5.6c.7.5 1.5.8 2.4 1.1 1.7.1 3.4-2.2 3.4-3.8.2-1.8-2.7-3.7-3.9-4.7z",
    fill: "url(#N)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2 232.3h3.1v28.4h-3.1z",
    className: "n"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    gradientUnits: "userSpaceOnUse",
    x1: 95.42,
    y1: 260.25,
    x2: 97.456,
    y2: 239.352
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0,
    "shrefp-opacity": 0
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.99
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2 232.3h3.1v28.4h-3.1z",
    fill: "url(#O)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M112.8 263.9c0 2.1-7.2 3.8-16 3.8s-16-1.7-16-3.8c-.1-.8-.1-1.5 0-2.4 1.2-1.8 8-1.4 16-1.4 7.8 0 14.5-.3 16 1.4.1.8.1 1.6 0 2.4z",
    className: "p"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.8,
    cy: 261.5,
    rx: 16,
    ry: 3.8,
    className: "n"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M126.3 226.3c.1 1.6-.3 3.3-.9 4.9h-.1l-5.3.1-8.8 1.3-4 .8-3.8.8-7.1 1.2c-2.9-1.3-5.5-3.2-7.7-5.5l-.6-.9-.8-1.1c-.7-1.1-1.2-2.3-1.4-3.5-.1-.5 0-1.1.1-1.5.5-1.7 1.5-3.3 3.1-4.3l.5-.4c3.3-2.3 7.1-3.3 11-3.3.4 0 .6 0 1 .1 2.1.2 4.2.5 6.2 1.1 3.3.8 6.4 2 9.6 3 2.4.6 4.6 1.6 6.7 2.9a6.73 6.73 0 011.5 1.4c.5.9.8 1.9.8 2.9z",
    className: "o"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse",
    x1: 120.335,
    y1: 192.47,
    x2: 92.929,
    y2: 272.961
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0,
    "shrefp-color": "#e5c5d5"
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.42,
    "shrefp-color": "#ead4d1"
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    "shrefp-color": "#f0e9cb"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M126 231.4c-.5 2.2-.8 4.3-1.1 6.4l-1.1 8.9c-.5 2.9-.4 5.9-.9 8.8-.3 1.1-.4 2.2-.4 3.3.2 1.5.5 3.1 1.2 4.4-.1.2-.4.2-.5.1-1.2-.3-2.4-.6-3.3-1.2-1.1-.5-2-1.4-2.4-2.5-.6-1.6-.1-3.4-.2-5.1-.2-1.8-.5-3.5-1.1-5.2-1.3-5-4.6-9.4-4.4-14.7.1-.6 0-1.4-.4-1.9-.6-.8-3.3.5-4.1.6l-3.8.8c-6.9 1.4-13.2 2.9-20.2 1.5-.5-.1-.8-.2-1.2-.5-.5-.4-.7-.9-.8-1.4-1-3.1-.7-6.4.7-9.3 1.7-3.3 4.4-4.7 7.6-6.3 3.7-1.8 6.8-3.3 11-3.2.4 0 .6 0 1 .1 2.1.2 4.2.5 6.2 1.1 5.2 1.4 17.1 3.3 19.1 9.2.6 1.9-.2 3.4-.5 5.2-.3.4-.3.7-.4.9z",
    fill: "url(#P)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M116.9 258.9l.2-.2c.4-.1.6.3.8.5.8 1.4 2 2.4 3.4 2.9.2.1.4.1.5.1.2-.1.4-.4.5-.5.3-.2.6-.3.9-.2s.6.3.8.5c.8.5 1.5 1.2 2.3 1.8.4.4.7.9.5 1.4-.2.3-.4.5-.6.5-1 .3-2.1.3-3.1-.1-1.8-.6-3.4-1.7-5.2-2.4-.1-.1-.3-.1-.4-.1s-.2 0-.3.1c-.4 0-.6-.2-.8-.5-.8-1.2-.7-2.8.5-3.8z",
    className: "o"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    gradientUnits: "userSpaceOnUse",
    x1: 111.807,
    y1: 229.746,
    x2: 149.866,
    y2: 272.892
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0,
    "shrefp-color": "#e5c5d5"
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.42,
    "shrefp-color": "#ead4d1"
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    "shrefp-color": "#f0e9cb"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M134.5 232.5c.8 2 1.2 4.2 1.1 6.3 0 5.5-1.5 11-3.1 16.3-.6 2.3-1.2 4.5-1.9 6.8-.5 1.6-1.3 2.8-.2 4.5.2.3.5.6.6 1 .2.4.1.8-.1 1.1-.4.4-1.1.1-1.5-.1-1.3-.4-2.4-.8-3.6-1.3-2.3-1.3-1.4-2.8-1-4.8.5-2.4.7-4.7 1-7.1.6-4.8.5-9.7-.4-14.4-.1-.5-.3-1.1-.6-1.5-.5-.4-1-.6-1.6-.6-8.1-1.4-16.1-1.9-23.9-5.1-3.1-1.2-6.1-2.7-8.8-4.5-.4-.3-.7-.6-1.1-1.1-.2-.2-.3-.4-.4-.5-.5-.8-.7-1.7-.6-2.6 0-.3.1-.5.1-.7.2-.5.5-1 .8-1.4a5.51 5.51 0 012-1.7c1.9-1.4 4.2-2.2 6.5-2.4 1.6-.1 3.2.3 4.7.2 1.4-.1 2.4-.8 3.6-1a6.72 6.72 0 012.8.3c2.1.7 4.1 1.6 6.1 2.7l7.1 3.5c3.3 1.6 7.2 2.7 10 5 1 .6 1.9 1.8 2.4 3.1z",
    fill: "url(#Q)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M127.1 220.7c6.1 3.7 9.8 10.3 9.9 17.4-5.8 4.3-12.4 7.3-19.5 8.8a3.31 3.31 0 01-2.4 0c-.6-.4-1.3-.8-1.7-1.4-6.4-6.6-17.8-6-24.6-12.3-2.5-2.4-4.3-6.5-2.2-9.4.8-1 1.8-1.8 3-2.4 5.2-3.2 11.5-7.9 17.8-6.8 6.4 1.1 14.2 2.8 19.7 6.1z",
    className: "l"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    gradientUnits: "userSpaceOnUse",
    x1: 86.75,
    y1: 250.386,
    x2: 136.531,
    y2: 217.431
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.08,
    "shrefp-opacity": 0.69
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.21,
    "shrefp-opacity": 0.32
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    "shrefp-opacity": 0
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M129.6 243c-3.3-3.4-3.8-8.5-4.3-13.2-.9.8-2 1.4-3.1 1.9l-.5-1.4c0-.3-.3-.5-.5-.4-.1 0-.1 0-.2.1-4.6 1.5-9.4 2.4-14.3 2.4-1.8 0-3.8-.1-5.3-1.2s-2.4-3.3-1.2-4.9c-3.9 1.1-7.9 1.8-11.9 2.4-.4 0-.6.1-.9.4-.3.4 0 1 .3 1.4 3.3 4.5 8.1 7.6 13.6 8.7 1.5.3 9.7 3.3 13.3 8.1.5.6 1.4.9 2.2.7l12.8-5z",
    fill: "url(#R)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Z",
    className: "o"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    gradientUnits: "userSpaceOnUse",
    x1: 104.384,
    y1: 225.186,
    x2: 82.978,
    y2: 244.808
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0,
    "shrefp-opacity": 0
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.99
  }))), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Z",
    fill: "url(#S)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M181.1 204.7v3.3H49.9l-.5-3.3h131.7z",
    className: "l"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    gradientUnits: "userSpaceOnUse",
    x1: 116.352,
    y1: 166.711,
    x2: 102.223,
    y2: 166.711
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0,
    "shrefp-color": "#e5c5d5"
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.42,
    "shrefp-color": "#ead4d1"
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    "shrefp-color": "#f0e9cb"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M114.9 158.8c-.5-.4-.9-.6-1.4-.8-1.5-.5-3.7-.6-5 .6-1.3 1.3-1.2 2.9-1.4 4.4-.5 2.3-1.4 4.3-2.8 6.2-.9.9-1.5 1.9-2 3.1-.1.4-.1.8 0 1.2.3.4.5.7 1 .9.9.6 2 1.2 3.1 1.4.7.2 1.5 0 2.2-.5.5-.5 1-.7 1.6-.6.6.2 1.3.3 2 .4 1.1-.2 1.9-.9 2.2-1.9s.5-2 .5-3.1c.3-2.7 1.4-5.3 1.5-8.1.1-1.2-.4-2.4-1.5-3.2z",
    fill: "url(#T)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.3 173.3a1.39 1.39 0 00-.2 1.1c.2.4.5.5.9.5 2.6.1 5.2.7 7.6 1.9.5.3 1.2.5 1.5 0 .2-.4.2-.8 0-1.3-.2-.4-.5-.6-.8-.8l-3.3-2.1c-2-1.3-4.1-1.9-5.7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.4 215.7c1.3 2.4 3.8 3.9 1.3 6.4-4.5 4.3-12.5 6.2-18.6 6.2-4.1 0-8.2-1-11.4-3.5-1-.7-1.7-1.6-2.2-2.8-.3-.7-.4-1.5-.4-2.3-.8-14.3 4.3-28.3 11.4-40.7 1.4-2.4 3.2-4.9 5.9-5.3 1-.1 2 0 2.9.2 6.3 1.1 12.6 2.5 18.8 4.4.8.2 1.6.5 2.3 1 .5.5.9.9 1.3 1.5l9.8 14.9c1.4 2.2 2.9 4.5 2.7 7.1 0 .7-.3 1.4-.7 2.1-.7.7-1.7 1.1-2.7 1.2-3.5.5-7.2.4-10.7-.7 1.9-1.4 1.4-4.5.1-6.6-.9-1.4-1.9-2.6-3.2-3.7-.8 4.1-2.2 8-4 11.7-1.6 2.6-4.2 5.7-2.6 8.9z"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M116.7 159.2c.3-.9.4-1.9.1-2.8a9.07 9.07 0 00-2-3.6c-1.8-2.2-4.2-4.1-7-4.5-7.6-1.3-16.4 6.5-19.3 12.9-1.8 4-2.4 8.4-3.3 12.8s-2.6 8.7-6.1 11.5c-1.4 1.2-3.1 2.1-3.9 3.6-1 1.9-.5 4.4.9 6.2 1.2 1.5 2.8 2.2 4.3 3.3 1.4 1 2.5 2.4 3.3 4 1.7 3.3 2.4 7.2 4.5 10.4l3.1-1.7c2.6-1.3 5.1-3 7.2-5.1 2-2.2 3.4-5.2 2.9-8.1-.3-1.7-1.3-3.3-1.8-5.1-1.7-5.3 2.1-7.5 5.3-10.7a9.82 9.82 0 002.8-8.6c-.6-1.7 0-3.7 1.5-4.7 1.4-1.7.3-3.9 2-5.5 1.3-1.3 3.3-1.4 4.4-2.7.7-.7.9-1.1 1.1-1.6z",
    className: "p"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    gradientUnits: "userSpaceOnUse",
    x1: 47.947,
    y1: 253.453,
    x2: 125.795,
    y2: 175.614
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.08,
    "shrefp-opacity": 0.69
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.21,
    "shrefp-opacity": 0.32
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    "shrefp-opacity": 0
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6 196.5c.5-1.9 1-3.7 1.8-5.5 3.5 2.5 6.2 7.4 7.4 11.6 1.3 4.2 2.4 8.5 5.1 11.9l2.9-1 .5 1.8c.5 1.4-.8 2.9-.6 4.3.3 1.5 1.4 2.7 3 3.1 1.7.4 3.4.2 5.1-.4 1.1-.2 2.1-.6 2.9-1.3.9-.6 1.4-1.8 1.1-2.9.7.5 1.1 1.3.8 2.1s-.7 1.4-1.4 1.9c-2 1.8-4.5 2.7-7.1 3.7-1.2.5-2.4.9-3.6 1.3-2.9.6-5.8.9-8.7.9-1.8 0-2.8-.3-3.6-2-1.1-2.5-1.2-5.3-1.4-8.1-1.1-7.1-2.4-14.3-4.2-21.4z",
    fill: "url(#U)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    className: "o"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    gradientUnits: "userSpaceOnUse",
    x1: 55.246,
    y1: 211.263,
    x2: 89.2,
    y2: 211.263
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0,
    "shrefp-opacity": 0
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 0.99
  }))), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "url(#V)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M124.1 264.4l.2-.2c.4-.1.6.3.8.5.8 1.4 2 2.4 3.4 2.9.2.1.4.1.5.1.2-.1.4-.4.5-.5.3-.2.6-.3.9-.2s.6.3.8.5c.8.5 1.5 1.2 2.3 1.8.4.4.7.9.5 1.4-.2.3-.4.5-.6.5-1 .4-2.1.3-3.1-.1-1.8-.6-3.4-1.7-5.2-2.4-.1-.1-.3-.1-.4-.1s-.2 0-.3.1c-.4 0-.6-.2-.8-.5-.7-1.1-.6-2.8.5-3.8z",
    className: "o"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M151 150.8l-5.5 1.2v-24.4l5.5-1.1zm7.2-1.6l-5.4 1.2V132l5.4-1.2zm7.4-1.6l-5.5 1.2v-33.4l5.5-1.3zm7.3-1.6l-5.4 1.3v-40.8l5.4-1.1z",
    className: "l"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M141.8 152.7l34.9-7.1v-40.1",
    fill: "none",
    stroke: "#2f3554",
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7 120.3c.3.1.5.2.7.3l2.2 1.2c.1.1.2.1.4.2h.4c3.1-.6 3.1-4.7.6-6.1-.5-.2-.9-.5-1.4-.8-.4-.4-.6-.7-.9-1.1-.4-.4-.8-.5-1.3-.5-.5.2-.7.5-.7 1-.1.5-.2.9-.4 1.3-.2.3-.3.5-.5.7l-.8 1.1c-.3.4-.4.8-.4 1.3.2.5.5.9 1.1 1.1l1 .3z",
    className: "q"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 136.7c.4.7.6 1.4.8 2.3 0 1.6-.7 3.1-2.1 4.1-1.7 1.4-3.9 2.4-6.2 2.5-.5.1-1.2 0-1.7-.3-.7-.5-1.3-1.2-1.6-2-2.8-5.8-5.9-12.9-6.2-19.5-.1-2 1.6-5.6 4.1-4.3 2.6 1.4 5.1 5.1 6.8 7.4 2.4 3.2 4.5 6.3 6.1 9.8z",
    className: "m"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "X",
    d: "M211.3 231.9c.5 2.2.8 4.3 1.1 6.4.7 5 1.3 10 1.5 15.1.1.5 0 1-.1 1.4-.5 1.4-2.4 1.4-3.8 1.4s-3.3.5-3.3 2c0 1.1 1.3 1.8 2.3 2.2a27.16 27.16 0 009.8 1.5c.4 0 .8-.1 1.2-.2 2.3-1 .5-3.6.3-5.2-.4-2.3.5-4.6 1.1-6.8 1.3-5 4.6-9.4 4.4-14.7-.1-.6 0-1.4.4-1.9.6-.8 3.3.5 4.1.6 1.3.3 2.5.5 3.8.8 6.9 1.4 13.2 2.9 20.3 1.5.5-.1.8-.2 1.2-.4.5-.4.7-.9.8-1.4 1-3.1.7-6.4-.7-9.3-1.7-3.4-4.4-4.7-7.6-6.3-3.7-1.9-6.8-3.3-11-3.2-.4 0-.6 0-1 .1-2.1.2-4.2.5-6.2 1.1-5.2 1.4-17.1 3.3-19.1 9.2-.6 1.9.2 3.4.5 5.2-.2.3-.1.5 0 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    d: "M248 223.1l.1 2.4.2 2.4c0 .2 0 .4.1.5l.3 1.7v.1l.2 1c-.3 1.8-.1 3.6.6 5.2 1.6.1 3.3 0 4.8-.1 3.2-.2 6.2-.7 9.2-1.6 3.1-1.5 5.9-3.5 8.4-6 .7-.6 1.3-1.4 1.6-2.2a6.72 6.72 0 00.3-2.8c-.1-5.2.5-10.4 2-15.5.4-1.1.6-2.2 1.1-3.3l1.4-3.6c1.3-2.8 2.7-5.5 3.3-8.5.3-1.6.4-3.3.1-5 0-.3-.1-.5-.4-.8s-.6-.4-1-.3c-3.8.1-7.2 2.3-11 2.9-1.9.4-3.9.3-5.8.8-2.6.9-4.8 2.6-6.3 5-.8 1.2-1.5 2.4-2.2 3.8-1 2-1.9 3.9-2.7 5.7-.5 1.1-.9 2.2-1.4 3.3a41.93 41.93 0 00-2.9 10.5v.1c.1 1.5 0 3 0 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z",
    d: "M80.7 230c-1.2 0-2.6.2-3.3 1.3-.4.6-.4 1.4 0 2.2.4.6.9 1.2 1.6 1.4.9.4 1.8.6 2.7.8l11.7 2.2 5.9 1c1.5.3 3 1 4.6 1.4s3.7.5 5.1-.6c.8-.7 1.3-1.9 1.1-3-.1-.4-.2-.7-.5-1a3.04 3.04 0 00-.7-.5c-2.9-1.3-5.9-2.2-9-2.6l-6.3-1.3c-1.9-.5-3.9-.9-5.9-1.1-2.3-.3-4.6-.3-7-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M89.3 222.7l-.1 2.4-.2 2.4c0 .2 0 .4-.1.5l-.3 1.7v.1l-.2 1c.3 1.8.1 3.6-.6 5.2-1.6.1-3.3 0-4.8-.1-3.2-.2-6.2-.7-9.2-1.6-3.1-1.5-5.9-3.6-8.4-6-.7-.6-1.3-1.4-1.6-2.2-.3-.9-.4-1.8-.3-2.8.1-5.2-.5-10.5-2-15.5-.3-1.1-.6-2.2-1.1-3.3-.5-1.2-.9-2.4-1.4-3.6-1.3-2.8-2.7-5.5-3.3-8.5-.4-1.6-.4-3.3-.1-5 0-.3.1-.5.3-.8.3-.3.6-.4 1-.3 3.8.1 7.2 2.3 11 2.9 1.9.4 3.9.3 5.8.8 2.6.9 4.9 2.6 6.3 5 .8 1.2 1.5 2.4 2.2 3.8 1 2 1.9 3.9 2.7 5.7.5 1.1.9 2.2 1.4 3.3a41.93 41.93 0 012.9 10.5v.1c0 1.5.1 2.9.1 4.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFig2);
export default __webpack_public_path__ + "static/media/fig2.378aeb613b931cb6b37dca77a8c7c748.svg";
export { ForwardRef as ReactComponent };